<template>
  <div class="jpjflix">
    <div class="container">
      <img class="m-4" src="/img/JPJFLIX-logo-image.png" width="80%" />

      <h3 class="flix">ジャムセッションしながらMusic Videoが作れる!?</h3>

      <iframe
        width="100%"
        src="https://www.youtube.com/embed/CM3C7LxctwM"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <span class="small">
        参考映像
        撮影 : Fog Bound Film Works
        会場 : 渋谷Under Deer Lounge
      </span>
      <br />
      <br />

      <p>
        「JPJFLIX」は
        東京で一番POPなジャムセッション「J-POP JAM」が
        お届けする新たな企画イベント。
      </p>
      <p>
        渋谷UnderDeerLounge全面協力の元、
        プロカメラマン、プロミュージシャンによる
        “シンガー限定”ジャムセッション×撮影。
      </p>
      <p>
        映像は、後日編集しMusic Videoとして提供
        ご自身のSNS等で自由にお使い頂けます。
      </p>
      <p>
        歌を引き立たせる、ピアノとギターの
        シンプルなサウンドでサポート。
      </p>
      <p>
        時間・費用のかかるMusic Video制作を、
        ジャムセッションを楽しみながら
        低価格・高品質で実現しようという試みです。
      </p>
      <p>
        日頃歌ってみた動画にチャレンジしている方、
        なかなかチャレンジするキッカケがなかった方、
        この機会に本格的なMusic Video制作をしてみませんか？
      </p>

      <h2 class="flix">
        9/13(sun)
        <br />Open 14:00 Start 14:30
      </h2>
      <a class="link" href="https://under-dl.jp/">
        <u>@渋谷Under Deer Lounge</u>
      </a>

      <p>
        チケット (完全予約制・限定20名)
        <br />5000円+1drink (撮影付きセッション)
        <br />3000円+1drink (セッションのみ)
        <br />1500円+ 1drink (観覧)
        <br />
      </p>
      <p class="link">HOST</p>
      <p>
        Agt.宮本憲 Key.田中綾美 Vo.蒲原彰利
        Fogbound Film Works (撮影)
      </p>

      <h3 class="flix">ご来場のお客様へのお願い</h3>
      <p>
        新型コロナウイルス感染防止対策として、
        当日は、マスクの着用と入口にて検温・消毒に
        ご協力をお願い致します。
        体調の優れない方はご参加をお控えください。
      </p>
      <p>
        より多くの方にセッションを楽しんで頂くためs
        楽曲は、基本3分程度のShort verとなっております。
        (ex.1コーラス→Cメロ→ラストサビetc)
      </p>
      <div class="mt-5">
        <a class="link" href="https://forms.gle/LoqYUDZGnx5TnrNt5">
          <base-button type="danger">予約フォームはこちら</base-button>
        </a>
      </div>
      <div class="mt-5">©︎2020 J-POP JAM TEAM</div>
    </div>
  </div>
</template>


<script>
import firebase from "firebase/app";

export default {
  name: "event",
  data() {
    return {
      nowJoinSession: {},
      trackList: {},
      result: "",
    };
  },
  computed: {
    nowJoinSessionInfo() {
      return this.$store.state.nowJoinSessionInfo;
    },
  },
  created() {
    firebase
      .database()
      .ref("eventList/")
      .on("value", (snapshot) => {
        var eventList = snapshot.val();
        this.nowJoinSession = eventList[this.nowJoinSessionInfo];
        const MarkdownIt = require("markdown-it");
        const meta = require("markdown-it-meta");
        const md = new MarkdownIt();
        md.use(meta);
        const result = md.render(this.nowJoinSession.eventDetail);
        this.result = result;
      });

    firebase
      .database()
      .ref("trackList/")
      .on("value", (snapshot) => {
        this.trackList = snapshot.val();
      });
  },
  methods: {
    thumbUrl(id) {
      return "http://img.youtube.com/vi/" + id + "/mqdefault.jpg";
    },

    alt() {
      window.alert("外部サイトへ飛びます");
    },
  },
};
</script>

<style>
.jpjflix {
  background: url(/img/bg-3D-v02-sozai-webBG.jpg);
  color: white;
}
.flix {
  color: #ec2517;
}
.link {
  color: white;
}
.small {
  font: 100;
}
</style>